import { useTokenStore } from "@/stores/token"

let isRefreshing = false
let refreshPromise = null

async function refreshTokens() {
	const tokenStore = useTokenStore()
	const refreshToken = tokenStore.getRefreshToken()

	try {
		const response = await fetch("/api/refresh", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ refresh_token: refreshToken }),
		})

		if (!response.ok) {
			throw new Error("Failed to refresh token")
		}

		const data = await response.json()
		// console.log("NEW TOKENS ASSIGNED", data)
		await tokenStore.setTokens(data.access_token, data.refresh_token)
		return data.access_token
	} catch (error) {
		// alert("IN HERE - REFRESH ERROR")
		await tokenStore.clearTokens()
		window.location = "/signin"
		throw error
	}
}

export async function fetchWithAuth(url, options = {}) {
	const invalidCodes = [499, 498, 401]

	const tokenStore = useTokenStore()
	options.headers = options.headers || {}

	if (tokenStore.hasToken()) {
		options.headers.Authorization = `Bearer ${tokenStore.getAccessToken()}`
	}

	const handleNewToken = async (response) => {
		const data = await response.json()
		await tokenStore.setTokens(data.access_token, data.refresh_token)
		window.location.reload()
	}

	const handleAuthError = async (response) => {
		// const oldToken = tokenStore.getAccessToken()
		// if (response.status === 401) {
		// window.location = "/suspended"
		// throw new Error("User is suspended")
		// } else if (response.status === 403) {
		// if (response.status === 403) {
		if (invalidCodes.includes(response.status)) {
			if (!tokenStore.getRefreshToken() || tokenStore.isRefreshTokenExpired()) {
				// alert("IN HERE - INVALID NO REFRESH TOKEN")
				await tokenStore.clearTokens()
				window.location = "/signin"
				throw new Error("Refresh token expired")
			}

			let newToken
			if (isRefreshing) {
				newToken = await refreshPromise
			} else {
				isRefreshing = true
				refreshPromise = refreshTokens().finally(() => {
					isRefreshing = false
					refreshPromise = null
				})
				newToken = await refreshPromise
			}

			// options.headers.Authorization = `Bearer ${tokenStore.getAccessToken()}`
			options.headers.Authorization = `Bearer ${newToken}`

			// console.log("TOKEN", tokenStore.getAccessToken(), oldToken, newToken)
			const retryResponse = await fetch(url, options)

			// if (retryResponse.status === 401) {
			// 	window.location = "/suspended"
			// 	throw new Error("User is suspended")
			// } else if (retryResponse.status === 403) {
			if (invalidCodes.includes(retryResponse.status)) {
				// alert("IN HERE - INVALID")
				await tokenStore.clearTokens()
				window.location = "/signin"
				throw new Error("Invalid token")
			}

			return retryResponse
		} else if (response.status === 420) {
			await handleNewToken(response)
		}

		return response
	}

	try {
		const response = await fetch(url, options)
		if (response.ok) {
			return response
		} //else if ([401, 403].includes(response.status)) {
		else if (response.status === 420) {
			return await handleNewToken(response)
		} else if (invalidCodes.includes(response.status)) {
			return await handleAuthError(response)
		} else {
			return response
		}
	} catch (error) {
		throw error
	}
}
